/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VisibilityFilterResponse {
    getFixupPrototypeFunction() { return VisibilityFilterResponse.fixupPrototype; }

    static newInstance(model: Partial<VisibilityFilterResponse>): VisibilityFilterResponse {
        let obj = Object.assign(new VisibilityFilterResponse(), model);
        VisibilityFilterResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VisibilityFilterResponse>): VisibilityFilterResponse {
        if (!model) return null;
        return VisibilityFilterResponse.newInstance(<VisibilityFilterResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VisibilityFilterResponse) {
        if (!obj) return;

        models.VisibilityFilterResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VisibilityFilterResponse): boolean {
        Object.setPrototypeOf(obj, VisibilityFilterResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cloud_accounts) {
            for (let val of this.cloud_accounts) {
                models.ServiceAccountsModel.fixupPrototype(val);
            }
        }
        if (this.guardrails) {
            for (let val of this.guardrails) {
                models.GuardrailModel.fixupPrototype(val);
            }
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.ProjectsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Service accounts to filter violations based on service accounts
     */
    cloud_accounts: Array<models.ServiceAccountsModel>;

    /**
     * Guardrail to filter violations based on guardrail
     */
    guardrails: Array<models.GuardrailModel>;

    /**
     * Tenants to filter violations based on tenant
     */
    tenants: Array<models.ProjectsModel>;

}
